<div
  [id]="dragZone"
  class="drop-list"
  [ngClass]="items && items.length === 0 ? 'no-scroll-drop-list' : ''"
  cdkDropList
  [class.item-dragging]="dragging"
  (cdkDropListDropped)="droppedIntoList($event)"
>
  <ng-container *ngIf="filteredItems && filteredItems.length > 0; else emptyTemplate">
    <div class="d-flex flex-column align-items-stretch justify-content-start" style="height: auto; min-height: 0;">
      
      <div
        *ngFor="let item of filteredItems; let index = index"
        class="item"
        [class.selected]="isSelected(item)"
        cdkDrag
        (cdkDragStarted)="dragStarted($event, item)"
        (cdkDragEnded)="dragEnded()"
        (cdkDragDropped)="dropped($event)"
        (click)="select($event, item)"
      >
        <div *ngIf="!dragging || !isSelected(item)">
          <ng-container
            *ngTemplateOutlet="
              templateRef;
              context: { $implicit: item, item: item, index: index }
            "
          ></ng-container>
          <div *cdkDragPreview>
            <div class="select-item-drag-preview float-start">
              {{ selections.length || 1 }}
            </div>
            <ng-container
              *ngTemplateOutlet="
                templateRef;
                context: { $implicit: item, item: item, index: index }
              "
            ></ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #emptyTemplate>
    <div class="d-flex flex-column align-items-center justify-content-center" style=" min-width: 220px;">
      <p *ngIf="searchText && items.length > 0">Aucun résultat pour "{{searchText}}"</p>
      <ng-container *ngTemplateOutlet="empty"></ng-container>
    </div>
  </ng-template>
</div>